import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl4AutoValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    dateFrom: yup.date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")).required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocIsologismos: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    dateTo: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(
        yup.ref("dateFrom"),
        t(
          "Η ημερομηνία λήξης δεν μπορεί να είναι μικρότερη από την ημερομηνία έναρξης"
        )
      ),
    acceptedFinancialReport: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
